import { useAnchorScroll } from '@hooks/useAnchorScroll';
import Anchor from '@wconcept/wconcept-ui/src/components/atoms/Anchor';
import { createContext, memo, useContext } from 'react';

/**
 * 일반 프로모션은 페이지 단위로 앵커 이동을 처리해 중복 실행을 막는다.
 * Provider 밖의 랭킹/스페셜 화면은 각 모듈이 기존 방식으로 이동한다.
 */
const ShouldModuleHandleAnchorScrollContext = createContext(true);

export function PageManagedAnchorScrollProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <ShouldModuleHandleAnchorScrollContext.Provider value={false}>
      {children}
    </ShouldModuleHandleAnchorScrollContext.Provider>
  );
}

// 공통 모듈 래퍼 컴포넌트 (Anchor 스크롤 기능 포함)
function ModuleAnchorWrapper({
  order,
  children,
  className,
  id,
  registerModule,
  contentId,
  isDesktop,
}: {
  order: number;
  children: React.ReactNode;
  className?: string;
  id?: string;
  registerModule?: (contentId: string, element: HTMLElement | null) => void;
  contentId?: string;
  isDesktop?: boolean;
}) {
  const enabled = useContext(ShouldModuleHandleAnchorScrollContext);
  useAnchorScroll({ order, isDesktop, enabled });

  // console.log('🔍 ModuleAnchorWrapper 렌더링:', {
  //   contentId,
  //   hasRegisterModule: !!registerModule,
  //   order,
  //   className,
  // });

  return (
    <Anchor
      className={className}
      id={`section${order}`}
      isRef={(element: HTMLElement | null) => {
        // 모듈 요소를 Intersection Observer에 등록
        // console.log('🔍 ModuleAnchorWrapper 등록:', {
        //   contentId,
        //   element: !!element,
        //   hasRegisterModule: !!registerModule,
        //   elementTag: element?.tagName,
        //   elementId: element?.id,
        // });
        if (registerModule && element && contentId) {
          // console.log('✅ 모듈 등록 실행:', { contentId, element });
          registerModule(contentId, element);
        } else {
          // console.warn('❌ 모듈 등록 실패:', {
          //   hasRegisterModule: !!registerModule,
          //   hasElement: !!element,
          //   hasContentId: !!contentId,
          // });
        }
      }}
    >
      {children}
    </Anchor>
  );
}

export default memo(ModuleAnchorWrapper);
